module.exports = __webpack_public_path__ + "media/src/public/img/pechat-2e28822be77af6109870593826098d52.png";